import type { Habit, Mood } from '../types'

/** Exactly 100 XP of base per day. Never change this total without instruction. */
export const habits: Habit[] = [
  { id: 'hydration', xp: 15, icon: 'droplet' },
  { id: 'movement', xp: 25, icon: 'activity' },
  { id: 'mind', xp: 15, icon: 'brain' },
  { id: 'nutrition', xp: 10, icon: 'salad' },
  { id: 'sleep', xp: 15, icon: 'moon' },
  { id: 'mood', xp: 20, icon: 'pulse' },
]

export const DAILY_BASE_XP = 100
export const PHOTO_BONUS_XP = 10
export const POST_GATE_XP = 50

export const moods: Mood[] = [
  // Icons come from the BEELYV icon system (moodGlyph in components/icons/Icon).
  { id: 'drained' },
  { id: 'tired' },
  { id: 'neutral' },
  { id: 'good' },
  { id: 'focused' },
]
